// 管理人天
import request from '@/utils/request'

// 添加
export function save(data) {
  return request({
    url: '/managerDay/saveOrUpdate',
    method: 'post',
    data
  })
}

// 提交
export function submit(data) {
  return request({
    url: '/managerDay/submitApproval',
    method: 'post',
    data
  })
}

// 删除
export function del(id) {
  return request({
    url: '/managerDay/delete/' + id,
    method: 'delete'
  })
}

